import React, { ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import './Tooltip.css';

interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delayDuration?: number;
}

const Tooltip = React.forwardRef<any, TooltipProps>(
  (
    {
      children,
      content,
      side = 'top',
      delayDuration = 200
    },
    ref
  ) => {
    // Don't render tooltip if content is empty
    if (!content || (typeof content === 'string' && content.trim() === '')) {
      return <>{children}</>;
    }

    return (
      <TooltipPrimitive.Provider>
        <TooltipPrimitive.Root delayDuration={delayDuration}>
          <TooltipPrimitive.Trigger asChild ref={ref}>
            {children}
          </TooltipPrimitive.Trigger>
          <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
              side={side}
              sideOffset={5}
              className="tooltip-content"
            >
              {content}
              <TooltipPrimitive.Arrow className="tooltip-arrow" />
            </TooltipPrimitive.Content>
          </TooltipPrimitive.Portal>
        </TooltipPrimitive.Root>
      </TooltipPrimitive.Provider>
    );
  }
);

Tooltip.displayName = 'Tooltip';

export default Tooltip;
